"use client";

import type { Locale } from "@i18n/react";
import type { Router } from "next/router";

import { getFramework } from "./utils/getFramework";

export { useServerInsertedHTML } from "next/navigation";

const framework = getFramework();

let initialized = false;
const initPromises: Promise<void>[] = [];

export let useSetLocale: () => {
  setLocale: ({ locale }: { locale: Locale }) => void;
};
if (framework === "next") useSetLocale = require("@i18n/next").useSetLocale;
else if (framework === "rr") {
  const p = import("@i18n/rr").then(({ useSetLocale: useSetLocaleRr }) => {
    useSetLocale = useSetLocaleRr;
  });
  initPromises.push(p);
} else
  /** TODO */
  useSetLocale = () => ({ setLocale: () => {} });

type UseParams = <
  T extends Record<string, string> = Record<string, string>,
>() => T;
export let useParams: UseParams;
if (framework === "next") useParams = require("next/navigation").useParams;
else if (framework === "rr") {
  const p = import("react-router").then((mod) => {
    useParams = mod.useParams as UseParams;
    usePath = () => mod.useLocation().pathname;
    useSearch = () => mod.useSearchParams()[0];
  });
  initPromises.push(p);
} else
  /** TODO */
  useParams = <T extends Record<string, string> = Record<string, string>>() =>
    ({}) as T;

export let usePath: () => string;
if (framework === "next") usePath = require("@i18n/next").usePathname;
else if (framework !== "rr") usePath = () => window?.location?.pathname;

export let useSearch: () => URLSearchParams;
if (framework === "next")
  useSearch = require("next/navigation").useSearchParams;
else if (framework !== "rr")
  useSearch = () => new URLSearchParams(window?.location?.search);

export let useRouter: () => Pick<
  Router,
  "push" | "replace" | "forward" | "back"
>;
if (framework === "next") useRouter = require("next/navigation").useRouter;
/* TODO */ else
  useRouter = () => ({
    forward: async () => {
      history.forward();
      return true;
    },
    back: history.back,
    push: async (url: string) => {
      history.pushState(null, null, url);
      return true;
    },
    replace: async (url: string) => {
      history.replaceState(null, null, url);
      return true;
    },
  });

/**
 * Ensures all framework-specific modules are loaded before use.
 * For react-router apps, call this before rendering to avoid timing issues.
 */
export async function ensureFrameworkReady(): Promise<void> {
  if (initialized) return;
  if (initPromises.length > 0) {
    await Promise.all(initPromises);
  }
  initialized = true;
}
